import { atom } from 'jotai';
import {
  endpointFundDocumentsGET,
  FundDocument,
  GetFundDocumentResponse,
} from '~/api/def/endpoints/fundEndpoint';
import { existingFundSetAtom } from '~/atoms/fundAtoms';

export type DocumentCacheSet = Map<string, FundDocument>;
export const documentCacheAtom = atom<DocumentCacheSet>(new Map());

/**
 * cacheDocumentFundMap is a map of document_id to fund_id
 */
const cacheDocumentFundMap = atom<Map<string, string>>(
  new Map<string, string>(),
);

const loadedFundsSetAtom = atom<Set<string>>(new Set<string>());

// export const existingFundSetAtom = atom<Set<string>>(new Set<string>());
/**
 * loads documents for a fund
 */
export const loadDocumentsAtom = atom(
  null,
  async (get, set, fundId: string) => {
    const documentsResponse = await endpointFundDocumentsGET(fundId);
    const existingFundSet = get(existingFundSetAtom);
    const loadedFundsSet = get(loadedFundsSetAtom);
    if (!existingFundSet.has(fundId) || loadedFundsSet.has(fundId)) {
      return;
    }
    if (documentsResponse?.success === 1 && 'data' in documentsResponse) {
      set(updateDocumentsActionAtom, documentsResponse.data);
      // documentsResponse.data.forEach((doc) => {
      //   documentCache.set(doc.id, {
      //     ...doc,
      //     admissionDate: doc.admissionDate ? new Date(doc.admissionDate) : null,
      //   });
      //   loadedFundsSet.add(fundId);
      //   documentsFundMap.set(doc.id, fundId);
      // });
    }
  },
);

export const updateDocumentsActionAtom = atom(
  null,
  (get, set, documents: GetFundDocumentResponse[]) => {
    const documentCache = get(documentCacheAtom);
    const documentsFundMap = get(cacheDocumentFundMap);
    const loadedFundsSet = get(loadedFundsSetAtom);
    documents.forEach((doc) => {
      documentCache.set(doc.id, {
        ...doc,
        admissionDate: doc.admissionDate ? new Date(doc.admissionDate) : null,
      });
      loadedFundsSet.add(doc.fundId);
      documentsFundMap.set(doc.id, doc.fundId);
    });
  },
);
